import { render, staticRenderFns } from "./receiving-data.vue?vue&type=template&id=7956569c&"
import script from "./receiving-data.vue?vue&type=script&lang=js&"
export * from "./receiving-data.vue?vue&type=script&lang=js&"
import style0 from "./receiving-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports